import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import {ESQuery} from 'cl-table/utils/elasticsearchUtils';

export default class DeleteProductsDialog extends React.PureComponent<
  {query?: ESQuery; count?: number} & SpecificFormDialogProps<{}>
> {
  render() {
    const {query, count, ...props} = this.props;
    return (
      <FormDialog
        formName={GENERAL_ACTIONS_TYPES.DELETE_PRODUCTS}
        title={count === 1 ? 'Delete Product' : 'Delete Products'}
        text={`Are you sure you want to delete ${count === 1 ? 'this product' : 'these products'}?`}
        actions={
          <GeneralActions
            additionalActionData={query}
            types={[GENERAL_ACTIONS_TYPES.DELETE_PRODUCTS]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            lastActionColor="error"
          />
        }
        {...props}
      />
    );
  }
}
